<template>
  <div class="content-wrap">
    <div class="content-header" v-if="!hideTitle">
      <b>等级评价</b>
    </div>
    <div class="search-table">
      <Table :columns="columns" :rows-data="listData">
        <template slot-scope="scope">
          <div v-if="scope.col.key === 'op'" class="table-op">
            <a v-if="scope.row.participateProgress != 109" @click="onShowSign(scope.row)">查看</a>
            <a v-if="scope.row.allowUploadApplyWordFlag == '1' " @click="reUploadScanningCopy(scope.row)">重新上传申报表</a>
            <a
              v-if="scope.row.participateProgress == 102"
              @click="onAddParcel(scope.row)"
              >添加快递信息</a
            >
            <a
              v-if="scope.row.participateProgress == 1011"
              @click="onUploadScanningCopy(scope.row)"
              >上传申报表</a
            >
            <!-- 草稿 -->
            <a v-if="scope.row.participateProgress == 109" @click="onAddParcel(scope.row)">继续报名</a>

            <!-- 驳回 -->
            <a v-if="scope.row.participateProgress == 101" @click="onContinueSignUp(scope.row)">继续报名</a>

            <a v-if="scope.row.participateProgress == 109 || scope.row.participateProgress == 101" @click="onDel(scope.row)">删除</a>
          </div>
          <!--<div v-if="scope.col.key === 'presentMethod'" class="table-op">
            123
          </div>-->
        </template>
      </Table>
      <Pagination
        :currentPage="currentPage"
        :total="total"
        @change="pageChange"
      />
    </div>
    <Modal :visible="signInfoVisible">
      <ParcelModal v-if="signInfoForm" @cancel="closeModal"  :signInfoRes="signInfoRes">
        <DynamicForm
          :config="signInfoConfig"
          :form="signInfoForm"
          :tabActive="signInfoTab"
          :disabled="true"
          @changeTab="idx => (signInfoTab=idx)"
        />
      </ParcelModal>
    </Modal>    
    <Modal :visible="reUploadScanningCopyVisible">
      <ReUploadScanningCopyModal
        @confirm="confirmUploadScanningCopy"
        @cancel="closeUploadScanningCopyModal"
      />
    </Modal>

  </div>
</template>

<script>
import router from "@/router";
import moment from "moment";
import Modal from "@/components/Modal";
import modal from '@/components';
import Pagination from "@/components/Pagination";
import ParcelModal from "./components/ParcelModal";
import ReUploadScanningCopyModal from "./components/ReUploadScanningCopyModal";
import { getUserAwardList, addParcelInfo, getAwardInfo,cancelSignUpAward,reUploadScanningCopy } from "./service/api";
import Table from "@/components/Table";
import DynamicForm from '@/pages/Activity/components/DynamicForm/index';
import { createFormAndConfig, setFormValue } from '@/pages/Activity/components/DynamicForm/service';

const progressMap = {
  100: "预审",
  101: "预审失败",
  102: "预审成功（快递实物）",
  103: "报名材料寄出",
  104: "实物签收",
  105: "评分公示",
  109: "草稿",
  1011: "上传扫描件",
};
export default {
  data() {
    return {
      columns: [
        {
          key: "title",
          dataIndex: "title",
          name: "等级评价标题",
          maxWidth: "200px",
        },
        {
          key: "activeBizTypeValue",
          dataIndex: "activeBizTypeValue",
          name: "项目类型",
          maxWidth: "100px",
        },        
        {
          key: "showTitle",
          dataIndex: "showTitle",
          name: "项目名称",
          maxWidth: "200px",
        },
        // {
        //   key: "actStartDate",
        //   dataIndex: "_actStartDate",
        //   name: "活动开始时间",
        // },
        // {
        //   key: "actEndDate",
        //   dataIndex: "_actEndDate",
        //   name: "活动结束时间",
        // },
        {
          key: "signUpProjectNo",
          dataIndex: "signUpProjectNo",
          name: "项目编码",
        },
        {
          key: "signUpTime",
          dataIndex: "_signUpTime",
          name: "报名时间",
        },
        {
          key: "participateProgress",
          dataIndex: "_participateProgress",
          name: "进度",
        },
        {
          key: "presentMethod",
          dataIndex: "_presentMethod",
          name: "送达方式",
        },
        // {
        //   key: "parcelCompany",
        //   dataIndex: "parcelCompany",
        //   name: "快递公司",
        // },
        // {
        //   key: "parcelNo",
        //   dataIndex: "parcelNo",
        //   name: "快递编号",
        // },
        // {
        //   key: "linkman",
        //   dataIndex: "linkman",
        //   name: "联系人",
        // },
        // {
        //   key: "phone",
        //   dataIndex: "phone",
        //   name: "电话",
        // },
        {
          key: "op",
          name: "操作",
        },
      ],
      listData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      parcelVisible: false,
      signInfoVisible: false,
      reUploadScanningCopyVisible: false,
      signInfoRes: null,
      signInfoTab: 0,
      signInfoConfig: null,
      signInfoForm: null,
      currentSignRecord: null,
      parcelForm: {
        parcelCompany: {
          value: "",
          error: false,
          validate: (v) => {
            if (!v) {
              this.parcelForm.parcelCompany.error = "请输入快递公司";
              return false;
            }
            this.parcelForm.parcelCompany.error = "";
            return true;
          },
        },
        parcelNo: {
          value: "",
          error: false,
          validate: (v) => {
            if (!v) {
              this.parcelForm.parcelNo.error = "请输入快递单号";
              return false;
            }
            this.parcelForm.parcelNo.error = "";
            return true;
          },
        },
      },
    };
  },
  props: {
    hideTitle: {
      default: false,
    },
  },
  components: {
    Modal,
    Table,
    Pagination,
    ParcelModal,
    DynamicForm,
    ReUploadScanningCopyModal
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
      };
      getUserAwardList(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
          item._actStartDate = moment(item.actStartDate * 1000).format(
            "YYYY-MM-DD"
          );
          item._actEndDate = moment(item.actEndDate * 1000).format(
            "YYYY-MM-DD"
          );
          item._signUpTime = moment(item.signUpTime * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          item._participateProgress = progressMap[item.participateProgress]
            ? progressMap[item.participateProgress]
            : "-";
          item._presentMethod = item.presentMethod =='1' ? '直接送达':item.presentMethod =='2'?'邮寄送达':'';   
          return item;
        });
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getData();
    },
    onAddParcel(row) {
      console.log(row);
      // debugger;
      router.push(`/activity/awards/sign?aId=${row.id}&signUpId=${row.signUpId}&fromUserCenter=1`);
      // this.parcelForm.id = row.id;
      // this.parcelForm.parcelCompany.value = row.parcelCompany;
      // this.parcelForm.parcelCompany.error = '';
      // this.parcelForm.parcelNo.value = row.parcelNo;
      // this.parcelForm.parcelNo.error = '';
      // this.parcelVisible = true;
    },

    onUploadScanningCopy(row) {
      console.log(row);
      router.push(`/activity/awards/sign?aId=${row.id}&signUpId=${row.signUpId}`);
    },    

    reUploadScanningCopy(row) {
      this.reUploadScanningCopyVisible = true;
      this.currentSignRecord = row
    },
    confirmUploadScanningCopy(fileList) {      
      reUploadScanningCopy({id:this.currentSignRecord.signUpId,scanningCopyFileList:fileList}).then((res) => {
        if(res){
          this.currentPage = 1;
          this.getData();
          this.$message({
            type: "success",
            content: "已重置申报表",
          });
        }            
      }).catch(error => {
        this.$message({
          type: 'error',
          content: error
        })
      }).finally(()=>{
        this.currentSignRecord = null
        this.reUploadScanningCopyVisible = false;
      })
    },
    closeUploadScanningCopyModal() {
      this.reUploadScanningCopyVisible = false;
      this.currentSignRecord = null;
    },
    
    onContinueSignUp(row) {
      console.log(row);
      router.push(`/activity/awards/sign?aId=${row.id}&signUpId=${row.signUpId}&fromUserCenter=1`);
    },    
    
    onParcelConfirm() {
      const params = {
        id: this.parcelForm.id,
        parcelCompany: this.parcelForm.parcelCompany.value,
        parcelNo: this.parcelForm.parcelNo.value,
      };
      addParcelInfo(params)
        .then(() => {
          this.getData();
          this.onParcelModalClose();
          this.$message({
            type: "success",
            content: "添加成功",
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            content: err,
          });
        });
    },
    onParcelModalClose() {
      this.parcelVisible = false;
    },
    onShowSign(row) {
      getAwardInfo(row.signUpId).then(res => {
        const { form, config } = createFormAndConfig(res.actFormConfigList, true);
        this.signInfoConfig = config;
        const signInfo = JSON.parse(res.signUpFormContent);
        this.signInfoForm = setFormValue(form, signInfo);
        this.signInfoVisible = true;
        this.signInfoRes = row;        
			}).catch(error => {
        this.$message({
				  type: 'error',
				  content: error
				})
      });
    },
    closeModal() {
      this.signInfoVisible = false;
      this.signInfoForm = null;
      this.signInfoTab = 0;
      this.signInfoRes = null; 
    },

    //删除
    onDel(row){
      modal.confirm({
        title: '您确认要取消该次报名?取消后将不可恢复！',
        // hideCancel: true,
        confirm:() => {
          //删除报名
          cancelSignUpAward({id:row.signUpId}).then((res) => {
            if(res){
              this.currentPage = 1;
              this.getData();
              this.$message({
                type: "success",
                content: "报名已取消",
              });
            }            
          }).catch(error => {
            this.$message({
              type: 'error',
              content: error
            })
          })
        },
      });
    }
  },
};
</script>

<style lang="less" scoped>
.content-header {
  padding: 20px;
  border-bottom: 1px solid #eeeeee;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  line-height: 20px;
  background: #ffffff;

  b {
    font-size: 20px;
    font-weight: 500;
    color: #131415;
    margin-right: 10px;
  }
}
.search-table {
  padding-top: 12px;
  min-height: 438px;
  background: #ffffff;
  padding-bottom: 30px;
}
.table-wrap {
  margin-bottom: 30px;
}
</style>